<template>
  <div class="street-quickbar">
    <a class="qk-btn" title="当前城市地图" @click="openMap">地图</a>
    <a class="qk-btn" title="打开背包" @click="openPocket">背包</a>
    <a class="qk-btn" title="任务列表" @click="openTaskList">任务</a>

    <!-- 背包弹窗（自带实例，不依赖左栏） -->
    <pocket
      v-on:ai_dialog_close="pocket_close"
      v-bind:pocketItems="pocketItems"
      v-bind:loading="pocketLoading"
      v-bind:dialogTableVisible="pocketVisible"></pocket>
    <!-- 任务列表弹窗（与左栏共用同一组件） -->
    <taskListDialog ref="taskListDialog"></taskListDialog>
    <!-- 当前城市地图弹窗 -->
    <wangdu-dialog ref="wangduDialog"></wangdu-dialog>
  </div>
</template>
<script>
import {getRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
import pocket from './pocket'
import taskListDialog from '../common/taskListDialog'
import wangduDialog from '../maps/wangduDialog'
export default {
  name: 'streetQuickBar',
  components: { pocket, taskListDialog, wangduDialog },
  data() {
    return {
      pocketVisible: false,
      pocketItems: [],
      // 请求期间显示 loading（与 streetleft 一致）
      pocketLoading: false
    };
  },
  methods: {
    openMap() {
      this.$refs.wangduDialog.open();
    },
    openPocket() {
      this.pocketVisible = true;
      this.pocketItems = [];
      this.pocketLoading = true;
      var _this = this;
      getRequest('/item/cabinet/openPocket', {}).then(resp=> {
        _this.pocketLoading = false;
        if (resp.status == 200) {
          var respData = resp.data;
          if (200 == respData.status) {
            _this.pocketItems = respData.data.pocketItems;
          } else { Message.error(respData.message); }
        } else { Message.error('用户非法⊙﹏⊙∥!'); }
      }, resp=> { _this.pocketLoading = false; Message.error('用户非法⊙﹏⊙∥!'); });
    },
    pocket_close() {
      this.pocketVisible = false;
    },
    openTaskList() {
      this.$refs.taskListDialog.open();
    }
  }
}
</script>

<style scoped>
/* 右下角常用功能快捷条：与音乐盒同为视口悬浮件（挂载点在 street-anim 外，不会被其
   包含块困住）；单行三键（存盘与左栏重复已去掉），占音乐盒原位贴底、经验条之上，
   音乐盒默认位置在本条上方 */
.street-quickbar {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 350;
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 6px;
  padding: 6px;
  background: rgba(45, 35, 64, 0.88);
  border: 1px solid #5a4f6c;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
}
.qk-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  box-sizing: border-box;
  height: 32px;
  padding: 0 10px;
  font-size: 13px;
  color: #f0e6d2;
  background: linear-gradient(180deg, #4a3f5c 0%, #3d3250 100%);
  border: 1px solid #5a4f6c;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  line-height: 1;
  letter-spacing: 0.5px;
  transition: all 0.15s;
}
.qk-btn:hover {
  color: #fff;
  background: linear-gradient(180deg, #5a4f6c 0%, #4a3f5c 100%);
  border-color: #d4a574;
}
.qk-btn:active {
  transform: translateY(1px);
}

/* 移动端：贴音乐盒原位（右下角、经验条底 14px 之上，不遮经验条） */
@media (max-width: 768px) {
  .street-quickbar {
    right: 4px;
    bottom: 18px;
    gap: 5px;
    padding: 4px;
    max-width: calc(100vw - 8px);
  }
  .qk-btn {
    font-size: 12px;
    height: 26px;
    padding: 0 7px;
  }
}

/* PC 端隐藏：快捷条仅服务移动端（PC 用左栏+顶栏入口），2026-10-02 用户拍板 */
@media (min-width: 769px) {
  .street-quickbar {
    display: none;
  }
}
</style>
